<template>
  <div class="backdrop">
    <div
      v-if="!isConfirmationOpen"
      class="modal"
    >
      <div class="header">
        <span class="title">{{ $t('search.feedbackModal.shareSomeDetails') }}</span>
        <span class="subtitle">{{ charCount }}/{{ maxChars }}</span>
      </div>
      <div class="body">
        <textarea
          v-model="feedbackText"
          class="textarea"
          :maxlength="maxChars"
          :placeholder="$t('search.feedbackModal.pleaseProvideAsMuchDetailAsPossible')"
        ></textarea>
      </div>
      <div class="footer">
        <button
          class="button cancel"
          :aria-label="$t('search.feedbackModal.cancel')"
          @click="closeFeedbackModal"
        >
          {{ $t('search.feedbackModal.cancel') }}
        </button>
        <button
          class="button submit"
          :aria-label="$t('search.feedbackModal.submit')"
          @click="submitFeedback"
        >
          {{ $t('search.feedbackModal.submit') }}
        </button>
      </div>
    </div>
    <div
      v-if="isConfirmationOpen"
      class="modal confirmation"
    >
      <div class="header">
        <span class="title">{{ $t('search.feedbackModal.thanksForYourFeedback') }}</span>
      </div>
      <div class="body">
        <span class="text">{{ $t('search.feedbackModal.yourInputHelpsUsFixIssuesAndImprove') }}</span>
      </div>
      <div class="footer">
        <button
          class="button close"
          :aria-label="$t('search.feedbackModal.close')"
          @click="closeConfirmationModal"
        >
          {{ $t('search.close') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
const emit = defineEmits(['closeFeedbackModal', 'submitFeedback', 'closeConfirmationModal']);
const feedbackText = ref('');
const maxChars = 500;
const isConfirmationOpen = ref(false);

const charCount = computed(() => feedbackText.value.length);

function submitFeedback() {
  isConfirmationOpen.value = true;
  emit('submitFeedback', feedbackText.value);
}

function closeFeedbackModal() {
  emit('closeFeedbackModal');
}

function closeConfirmationModal() {
  emit('closeConfirmationModal');
}
</script>

<style lang="scss" scoped>
.backdrop {
  --color-text-primary: #2d2d2d;
  --color-text-secondary: #616161;
  --color-grey-100: #e0e0e0;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background: rgba(34, 34, 34, 0.8);
  z-index: 101;
  .modal {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    flex-direction: column;
    gap: 16px;
    background: var(--primary-white);
    width: calc(50vw - 30px);
    height: calc(40vh);
    min-height: 240px;
    border-radius: 4px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 1px 14px -1px rgba(0, 0, 0, 0.14);
    box-sizing: border-box;
    padding: 24px;
    display: flex;
    gap: 12px;
    &.confirmation {
      height: 164px;
      width: 570px;
      min-height: unset;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .title {
      font-family: Inter;
      font-weight: 600;
      font-size: 20px;
      line-height: 120%;
      letter-spacing: 0px;
      color: var(--color-text-primary);
    }
    .subtitle {
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.1px;
      text-align: right;
      color: var(--color-text-secondary);
    }
    .body {
      flex: 1;
    }
    .text {
      font-family: Inter;
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0px;
    }
    .textarea {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      border: 1px solid var(--color-grey-100);
      padding: 16px;
      box-sizing: border-box;
      resize: none;
    }
    .footer {
      display: flex;
      gap: 16px;
      justify-content: flex-end;
      margin-top: auto;
    }
    .button {
      padding: 8px 16px;
      border-radius: 1000px;
      border-style: none;
      &:hover {
        cursor: pointer;
      }
    }
    .cancel {
      background-color: var(--secondary-button-background);
      color: var(--secondary-button-text);
      border: var(--secondary-button-border);
      &:hover {
        background-color: var(--secondary-button-hover);
      }
      &:focus-visible {
        outline: var(--secondary-button-focus-outline);
        outline-offset: 1px;
      }
    }
    .submit,
    .close {
      background-color: var(--primary-button-background);
      color: var(--primary-button-text-contrast);
      border: var(--primary-button-border);
      &:hover {
        background-color: var(--primary-button-hover);
      }
      &:focus-visible {
        outline: var(--secondary-button-focus-outline);
        outline-offset: 1px;
      }
    }
  }
}
</style>
